module.exports = __webpack_public_path__ + "img/fpt.315d8cbb.jpg";